<div mat-dialog-content class="text-center">
    <h2 class="title"> <i class="app-icon-tag"></i>PRECIFICAR</h2>
    <p style="color: white">
        Confirme os valores de precificação antes de aceitar a proposta.
    </p>

    <div class="row justify-content-center">
        <form [formGroup]="form" (submit)="submit()" class="col-md-9 value">
            <mat-form-field style="margin-top: -20px; width: 100%;">
                <span matPrefix class="currency-symbol">R$&nbsp;</span>
                <input matInput formControlName="price"currencyMask [options]="{
                        prefix: '',
                        thousands: '.',
                        precision: 2,
                        allowNegative: false
                    }" type="tel" />
                <mat-icon matSuffix style="font-size: 24px; color: #ffffff;">mode_edit</mat-icon>
            </mat-form-field>

            <div class="small-form-field" style="margin-top: 20px;">
                <label>Preço mínimo para venda</label>
                <mat-form-field style="width: 100%;">
                    <span matPrefix class="currency-symbol">R$&nbsp;</span>
                    <input formControlName="minSellPrice" matInput currencyMask [options]="{
                        prefix: '',
                        thousands: '.',
                        precision: 0,
                        allowNegative: false
                      }" type="tel" (click)="$event.stopPropagation()" />
                </mat-form-field>
            </div>

            <div class="small-form-field" style="margin-top: 20px;">
                <label>Preço para anúncio</label>
                <mat-form-field style="width: 100%;">
                    <span matPrefix class="currency-symbol">R$&nbsp;</span>
                    <input formControlName="listPrice" matInput currencyMask [options]="{
                        prefix: '',
                        thousands: '.',
                        precision: 0,
                        allowNegative: false
                      }" type="tel" (click)="$event.stopPropagation()" />
                </mat-form-field>
            </div>

            <div class="row justify-content-center mt-2">
                <button class="btn btn-primary btn-pill btn-text p-btn" type="submit">
                <div class="btn-spinner float-left" *ngIf="loadingUpdatePricing"></div>
                  Salvar
                </button>
              </div>
        </form>
    </div>
</div>